import { Helmet } from 'react-helmet';
import React from 'react';

const GoogleTagManager: React.FC<{}> = () => {
    // @ts-ignore
    const isProduction: boolean = window?.projectSettings?.isProduction === true;

    if (!isProduction) {
        return null;
    }

    return (
        <Helmet>
            <script>
                {`
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-NR68PDM')
              `}
            </script>
        </Helmet>
    );
};

export default GoogleTagManager;
